var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.832 19.2587V17.2587C17.832 16.1978 17.4106 15.1804 16.6605 14.4302C15.9103 13.6801 14.8929 13.2587 13.832 13.2587H5.83203C4.77117 13.2587 3.75375 13.6801 3.0036 14.4302C2.25346 15.1804 1.83203 16.1978 1.83203 17.2587V19.2587",
    stroke: "#4C6FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83203 9.25867C12.0412 9.25867 13.832 7.46781 13.832 5.25867C13.832 3.04953 12.0412 1.25867 9.83203 1.25867C7.62289 1.25867 5.83203 3.04953 5.83203 5.25867C5.83203 7.46781 7.62289 9.25867 9.83203 9.25867Z",
    stroke: "#4C6FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.3cc2af2d55221243247ab7f49b2e980e.svg";
export { ForwardRef as ReactComponent };